import styles from "./Hero.module.css";
const Hero = () => {
  return (
    <div className={styles.hero}>
      {/* <div className={`${styles.heroInner} mobile`}>
        <div className={styles.title}>
          <span>نرفــــــــــته برمــــــــــی‌گرده!</span>
        </div>
        <div className={styles.text}>
          <span>از بانی مد نقدی بخر، معادلش اعتبار تارا بگیر</span>
        </div>
        <div className={styles.info}>
          <div className={styles.infoIitems}>
            <div className={styles.infoIitem}>
              <span className={styles.infoText}>بدون پیش‌پرداخت</span>
              <span className={styles.dot} />
            </div>
            <div className={styles.infoIitem}>
              <span className={styles.infoText}>بدون سود و کارمزد</span>
              <span className={styles.dot} />
            </div>
            <div className={styles.infoIitem}>
              <span className={styles.infoText}>بازپرداخت در 3 قسط</span>
            </div>
          </div>
          <div className={`${styles.infoDesc} ${styles.infoText}`}>
            <span>
              اگر تا حالا اعتبار بانی‌مد رو از تارا نگرفتی، همین الان با خرید
              نقدی از
            </span>
            <span>بانی‌مد می‌تونی معادل مبلغ خریدت، اعتبار فوری بگیری.</span>
          </div>
        </div>
      </div> */}
      {/* <div className={styles.promotionBadge}>
        <span>تا ۱۵ میلیون تومان اعتبار فوری، بدون پیش پرداخت</span>
      </div> */}
      <div className={styles.image}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/image/hero-mobile.png`}
          alt="hero"
          className="mobile"
        />
        <img
          src={`${process.env.PUBLIC_URL}/assets/image/hero-desktop.png`}
          alt="hero"
          className="desktop"
        />
      </div>
    </div>
  );
};

export default Hero;
